const light = {
  red: "#E53E3E",
  redDark: "#C53030",
  blue: "#3A3AFF",
  blueDark: "#2C2CE5",
  green: "#38A169",
  greenDark: "#25855A",
  greenLight: "#DEF1E3",
  bg: "#E0E0FF",
  bgGradient:
    "linear-gradient(67deg, rgba(248, 248, 255, 0.70) 0%, rgba(248, 248, 255, 0.96) 29.5%, #F8F8FF 100%);",
  bgMaskColor: "#F8F8FF",
  grey: {
    black: "#121224",
    white: "#FFFFFF",
    900: "#16162B",
    800: "#22223F",
    700: "#2E2E5C",
    600: "#4B4B6A",
    500: "#6C7A8F",
    450: "#E0E6EE",
    400: "#909CAF",
    300: "#B0B0DA",
    200: "#E0E0FF",
    100: "#F0F0FF",
    50: "#F8F8FF",
  },
};

const dark = {
  red: "#E53E3E",
  redDark: "#C53030",
  blue: "#3A3AFF",
  blueDark: "#2C2CE5",
  green: "#38A169",
  greenDark: "#25855A",
  greenLight: "#DEF1E3",
  bg: "#121224",
  bgGradient:
    "linear-gradient(67deg, rgba(22, 22, 43, 0.20) 0%, rgba(22, 22, 43, 0.90) 29%, #16162B 100%)",
  bgMaskColor: "#16162B",
  grey: {
    black: "#FFFFFF",
    white: "#22223F",
    900: "#F8F8FF",
    800: "#F0F0FF",
    700: "#E0E0FF",
    600: "#B0B0DA",
    500: "#909CAF",
    450: "#E0E6EE",
    400: "#6C7A8F",
    300: "#4B4B6A",
    200: "#121224",
    100: "#2E2E5C",
    50: "#16162B",
  },
};

export { light, dark };
